import React from 'react';
import Modal from '../Utilities/Modal';

const PricingRulesModal = ({ isOpen, onClose, productData, pricingRules }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} modalWidth="w-full max-w-md">
            <div className="pricing-modal-container">
                {/* Header Tab */}
                <div className="pricing-modal-header">
                    قوانین قیمت گذاری
                </div>

                {/* Product Information */}
                <div className="text-center mb-6 mt-8">
                    <h3 className="text-lg font-bold pt-3 text-gray-800 mb-2">
                        {productData?.title || 'ماشین لباسشویی دوو سری سنیور 9 کیلویی'}
                    </h3>
    
                </div>

                {/* Pricing Rules Table */}
                <div className="mb-6">
                    {pricingRules?.filter(rule => rule.is_primary)?.map((rule, index) => (
                         <div key={index}>
                         <div className="pricing-rule-item">
                             <span className="text-gray-800 font-medium">سقف:</span>
                             <span className="text-gray-800 font-bold">{rule?.rule?.ceil ?? rule?.parent_rule?.ceil ?? '--'}</span>
                         </div>
                         <div className="pricing-rule-item !bg-white">
                             <span className="text-gray-800 font-medium">کف:</span>
                             <span className="text-gray-800 font-bold">{rule?.rule?.floor ?? rule?.parent_rule?.floor ?? '--'}</span>
                         </div>
                         <div className="pricing-rule-item">
                             <span className="text-gray-800 font-medium">مرز حداکثر:</span>
                             <span className="text-gray-800 font-bold">{rule?.rule?.max ?? rule?.parent_rule?.max ?? '--'}</span>
                         </div>
                         <div className="pricing-rule-item !bg-white">
                             <span className="text-gray-800 font-medium">مرز حداقل:</span>
                             <span className="text-gray-800 font-bold">{rule?.rule?.min ?? rule?.parent_rule?.min ?? '--'}</span>
                         </div>
                         <div className="pricing-rule-item">
                             <span className="text-gray-800 font-medium">پیش فروش:</span>
                             <span className="text-gray-800 font-bold">{rule?.rule?.presell ?? rule?.parent_rule?.presell ?? '--'}</span>
                         </div>
                        </div>
                    ))}
                </div>

                {/* Other Stores Section Header */}
                <div className="other-stores-header">
                    <div className="text-center text-sm font-bold text-gray-800">
                        کف قیمت سایر فروشگاه ها
                    </div>
                </div>

                {/* Other Stores Prices */}
                <div>
                    {pricingRules?.filter(rule => !rule.is_primary)?.map((store, index) => (
                        <div key={index} className="store-price-item">
                            <span className="text-gray-800 font-medium">{store.shop_title}</span>
                            <div className="dotted-line"></div>
                            <span className="text-gray-800 font-bold">{store?.rule?.floor ?? store?.parent_rule?.floor ?? '--'}</span>
                        </div>
                    ))}
                </div>

                {/* Close Button */}
                <div className="mt-6 text-center">
                    <button 
                        onClick={onClose}
                        className="bg-purple-600 text-white px-6 py-2 rounded-lg hover:bg-purple-700 transition duration-300"
                    >
                        بستن
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PricingRulesModal;
